import React, { memo } from 'react'

import { AIGeneratedGradientFilled, Button, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useSubscriptionHref } from 'Pods/ThreeDStudio/Hooks/useSubscriptionHref'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const FEATURE_KEYS = ['simultaneousGenerations', 'queuePriority', 'privateMode']
// Proper nouns / file formats, not translatable copy.
const TAG_GROUPS = [
  { key: 'dccBridge', tags: ['Blender', '3ds Max', 'Maya', 'Unity'] },
  { key: 'modelDownloads', tags: ['.glb', '.fbx', '.obj', '.stl', '.usdz'] },
]
const featureIconSize = { width: '18px', height: '18px' }

// Free-tier upsell card under the progress bar: subscription CTA plus the
// advanced-feature highlights.
function UpgradeNotice() {
  const t = useTranslation()
  const subscriptionHref = useSubscriptionHref()

  return (
    <div className="upgrade-notice">
      <div className="upgrade-notice__intro">
        <p className="upgrade-notice__title cgt-heading-100">
          {t('viewer.banner.unlockFeatures.title')}
        </p>
        <Button size="small" type="primary" href={subscriptionHref}>
          {t('viewer.banner.unlockFeatures.cta')}
        </Button>
      </div>
      <ul className="upgrade-notice__features">
        {FEATURE_KEYS.map((key) => (
          <li key={key} className="upgrade-notice__feature">
            <Icon
              svgComponent={AIGeneratedGradientFilled}
              size={featureIconSize}
              notSpaced
              className="upgrade-notice__feature-icon"
            />
            <span className="cgt-body-base">{t(`viewer.banner.unlockFeatures.${key}`)}</span>
          </li>
        ))}
      </ul>
      <div className="upgrade-notice__groups">
        {TAG_GROUPS.map(({ key, tags }) => (
          <div key={key} className="upgrade-notice__group">
            <div className="upgrade-notice__feature">
              <Icon
                svgComponent={AIGeneratedGradientFilled}
                size={featureIconSize}
                notSpaced
                className="upgrade-notice__feature-icon"
              />
              <span className="cgt-body-base">{t(`viewer.banner.unlockFeatures.${key}`)}</span>
            </div>
            <ul className="upgrade-notice__tags">
              {tags.map((tag) => (
                <li key={tag} className="upgrade-notice__tag cgt-caption-semibold">{tag}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(UpgradeNotice)
